import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApplicationService {
    public requestFullScreen: Subject<void> = new Subject();
    public requestNormalWindowMode: Subject<void> = new Subject();
}